import { oc } from 'ts-optchain';

import { StoreType } from '@tock/shared/utils/connect';
import { createDeepEqualSelector } from 'utils/service/selectorUtils';
import { forEach } from 'es-toolkit/compat';
import { isEqual } from 'es-toolkit';

let existing: Dictionary<number[]> | undefined = {};
export const serverIdToPartyIdsSelector = createDeepEqualSelector(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  (state: StoreType) => oc(state).service.app.app.serverIdToPartyIds()!,
  (serverIdToPartyIds: Dictionary<number[]>): Dictionary<number[]> => {
    if (serverIdToPartyIds && existing) {
      forEach(serverIdToPartyIds, (entry, key) => {
        if (existing && existing[key] && isEqual(entry, existing[key])) {
          serverIdToPartyIds[key] = existing[key];
        }
      });
    }
    existing = serverIdToPartyIds;
    return serverIdToPartyIds;
  }
);
